export default function addOrRemoveFromArray<T>(array: T[], value: T, compare = (a: T, b: T) => a === b) {
  const index = array.findIndex((arrayValue) => compare(arrayValue, value))

  if (index >= 0) {
    array.splice(index, 1)
  } else {
    array.push(value)
  }
  return [...array]
}
